import React from "react";
import Common from "./common";
import style from "css/lecture.module.css";
import { useMediaQuery } from "react-responsive";
import SEOMeta from "components/app/SEOMeta";
import { openPopup } from "redux/slices/drawerPopupSlice";
import { useDispatch } from "react-redux";
import NeatPopup from "components/device/neat/neatPopup";

function Group() {
  //dispatch
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  const HeaderInfo = {
    subTitle: "Hybrid Group Classroom",
    title: "하이브리드 그룹 강의실",
    info: [
      <font>
        학생들은 소규모 그룹으로 나누어{"\n"} 협력 학습을 진행할 수 있습니다.{" "}
        <br /> 각 그룹마다 화상회의 장비가 배치되어 있어, <br /> 팀원들이
        원활하게 소통하고 협력할 수 있습니다.{"\n"} {"\n"}
      </font>,
      <font>
        실시간으로 자료를 공유하고 공동 작업을 할 수 있는 <br /> 다양한 협업
        도구를 제공합니다.
      </font>,
    ],
    img: "img/smartspace/groupImg1.png",
    img_m: "img/smartspace/groupImg1_m.png",
  };

  const BodyInfo = [
    {
      id: 1,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                하이브리드 스마트 강의실에서 뛰어난 화상 회의 경험을 제공하는 AI
                기반의 화상 장비로,
              </font>
              <font>
                다양한 기능을 통해 교수와 학생 간의 상호작용을 극대화합니다.
              </font>
            </>
          ) : (
            <>
              <font>
                하이브리드 스마트 강의실에서 뛰어난 화상 회의 경험을 제공하는 AI
                기반의 화상 장비로, 다양한 기능을 통해 교수와 학생 간의
                상호작용을 극대화합니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "AI 화상 장비 ( AI remote learning device )",
      img: "img/smartspace/groupImg2.png",
      img_m: "img/smartspace/groupImg2_m.png",
    },
    {
      id: 2,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                AI 화상장비의 Boundary 기능은 프레임 공간을 설정하면 공간 안의
                사용자만을
              </font>
              <font>
                집중합니다. 공간 외의 사용자를 팔로우 하는 것을 방지 합니다.
              </font>
              <font>
                각 그룹에 배치된 화상장비는 그룹안의 사용자에게만 집중하도록
                비디오,오디오가
              </font>
              <font>컨트롤 됩니다.</font>
            </>
          ) : (
            <>
              <font>
                AI 화상장비의 Boundary 기능은 프레임 공간을 설정하면 공간 안의
                사용자만을 집중합니다. 공간 외의 사용자를 팔로우 하는 것을 방지
                합니다.{"\n"} 각 그룹에 배치된 화상장비는 그룹안의 사용자에게만
                집중하도록 비디오,오디오가 컨트롤 됩니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "그룹에 집중할 수 있는 Boundary 기술 ( Boundary )",
      img: "img/smartspace/groupImg3.png",
      img_m: "img/smartspace/groupImg3_m.png",
    },
    {
      id: 3,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                강의실 내 모든 디지털 장비(프로젝터·스마트
                보드·카메라·마이크·조명 등)를
              </font>
              <font>
                하나의 인터페이스에서 통합적으로 제어할 수 있는 소프트웨어
                프로그램 입니다.
              </font>
            </>
          ) : (
            <>
              <font>
                강의실 내 모든 디지털 장비(프로젝터·스마트
                보드·카메라·마이크·조명 등)를 하나의 인터페이스에서 통합적으로
                제어할 수 있는 소프트웨어 프로그램 입니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "스마트 강의 컨트롤 시스템",
      img: "img/smartspace/groupImg4.png",
      img_m: "img/smartspace/groupImg4_m.png",
    },
  ];

  const BodyFooter = [
    {
      id: 1,
      txt: "학생들은 소규모 그룹으로 나누어 협력 학습을 진행할 수 있습니다. 그룹별로 배치된 AI 화상 장비를 통해 학생들은 서로 협력하고, 문제를 해결하며, 공동 프로젝트를 수행할 수 있습니다. 이러한 협력 학습 환경은 학생들의 팀워크와 의사소통 능력을 향상시키는 데 크게 기여합니다.",
      title: (
        <p>
          <font> 협력 학습 </font>지원
        </p>
      ),
    },
    {
      id: 2,
      txt: "하이브리드 그룹 강의실은 AI 화상 장비를 통해 원격지에 있는 전문가 또는 학습자와 실시간으로 토론이 가능합니다. 이는 지리적 한계를 극복하고, 다양한 관점과 지식을 공유할 수 있는 기회를 제공합니다. 학생들은 원격지 전문가의 강의를 듣거나, 다른 지역의 학습자들과 협업하여 글로벌한 학습 경험을 쌓을 수 있습니다.",
      title: (
        <p>
          <font>원격지 전문가 </font>및 학습자와의 토론
        </p>
      ),
    },
    {
      id: 3,
      txt: "고해상도 디스플레이 · 스마트 보드 · 고성능 카메라 및 마이크 등 첨단 장비를 통해 생동감 있고 몰입감 있는 학습 환경을 제공합니다. 이러한 기술적 지원은 학습자들이 더욱 집중하고, 효과적으로 학습할 수 있도록 도와줍니다.",
      title: <p>첨단 기술 활용</p>,
    },
  ];
  const Compose = [
    {
      id: 1,
      img: "img/smartspace/composeImg2.png",
      title: "스마트 강의 컨트롤 시스템",
      txt: "스마트 강의 컨트롤 시스템은 강의실 내 장비와 디지털 콘텐츠를 통합 관리하여, 교수와 학생 모두에게 최적화된 학습 환경을 제공합니다. 실시간 강의, 화면 공유, 출석 관리 등을 손쉽게 운영할 수 있으며, 하이브리드 수업에 효과적으로 대응할 수 있도록 설계되었습니다.",
      onClick: () => showDrawer("deviceone"),
    },
    {
      id: 2,
      img: "img/device/neat/swiper_bar_2.png",
      title: "화상회의 장비 neat. bar generation2",
      txt: "Neat Bar는 화상 강의를 위한 고성능 장비로, AI 기반의 카메라 기능으로 수업 중 발표자에 집중할 수 있도록 하여, 원격 및 하이브리드 학습환경에서 최적의 강의 경험을 지원합니다.",
      onClick: () => showDrawer("bar2"),
    },
    {
      id: 3,
      img: "img/device/neat/swiper_bar_pro.png",
      title: "화상회의 장비 neat. bar",
      txt: "Neat Bar Pro는 강의실 전면에 설치하여 넓은 범위의 화자를 선명하게 포착하는 고성능 화상 강의 장비입니다. 대형 강의실에서도 몰입감 있는 수업 환경을 지원합니다.",
      onClick: () => showDrawer("bar"),
    },
    {
      id: 4,
      img: "img/device/neat/swiper_board_pro.png",
      title: "화상회의 장비 neat. board Pro",
      txt: "Neat Board Pro는 디지털 화이트보드와 화상회의 기능을 결합한 올인원 장비로, 강의실에서 실시간 협업과 몰입감 있는 강의를 지원합니다.",
      onClick: () => showDrawer("boardpro"),
    },
  ];
  const showDrawer = (menu) => {
    dispatch(
      openPopup({
        type: menu,
      })
    );
    document.querySelector("#page_header").style.height = "0";
  };
  const BodyHeader = (
    <div className={style.bodyTitle}>
      <p>소규모 그룹 프로젝트 및 토론 수업</p>
      <p>
        협력 학습과{"\n"} 상호작용에 중점을 둔{"\n"} 하이브리드 그룹 강의실
      </p>
      <p>
        소규모 그룹으로 나누어 협력 학습을 진행하며,{"\n"} 각 그룹마다 화상회의
        장비 배치 <br />팀 프로젝트와 토론 수업에서 원격지 전문가와의 실시간
        토론 가능, 협력적 학습 환경 조성
      </p>
    </div>
  );
  const BodyFooterTitle = (
    <div className={style.bodyFooterTitle}>
      <p>Riv Technology의{"\n"} 하이브리드 강의실 구축은 </p>
      <p>
        <font>강의실 환경에 맞춰 설계</font>되어,
      </p>
      <p>
        교수와 학생에게{"\n"} <font>혁신적인 학습 환경</font>을 제공합니다.
      </p>
    </div>
  );
  const ComposeHeader = (
    <div className={style.commonComposeTitle}>
      하이브리드 그룹 강의실 <font>구성 환경</font>
    </div>
  );

  return (
    <>
      <SEOMeta
        title="하이브리드 그룹 강의실, 리브테크놀로지"
        description="리브테크놀로지 riv Technolohy - 하이브리드 그룹 강의실"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, 스마트 회의실, 화상회의"
      />
      <NeatPopup />
      <div>
        <Common
          headerInfo={HeaderInfo}
          bodyHeader={BodyHeader}
          bodyInfo={BodyInfo}
          bodyFooter={BodyFooter}
          compose={Compose}
          bodyFooterTitle={BodyFooterTitle}
          composeHeader={ComposeHeader}
        />
      </div>
    </>
  );
}

export default Group;
